/**
 * Small pub/sub for surfacing the UpgradeModal from anywhere in the app
 * without prop-drilling. The AppLayout subscribes and renders the modal;
 * anyone can trigger it by calling `emitUpgradePrompt(detail)`.
 *
 * The axios interceptor in `lib/api.js` calls this automatically when a
 * 402 comes back with `{code: "upgrade_required", ...}`.
 */
let listeners = [];

export function subscribeUpgradePrompt(fn) {
  listeners.push(fn);
  return () => { listeners = listeners.filter(l => l !== fn); };
}

export function emitUpgradePrompt(detail) {
  for (const fn of listeners) {
    try { fn(detail); } catch (err) { console.warn("upgradePrompt listener threw", err); }
  }
}
